import { theme } from "@tm/utility/global";
import {
  resolveNetPriceField,
  useNetPriceContext,
} from "../mypartner/contexts/NetPriceContext";
import FlexComp from "../FlexComp/FlexComp";
import FormattedText from "../FormattedText/FormattedText";
import {
  PriceBreakupContainer,
  PriceBreakupTitle,
  PriceItemSeparator,
} from "./PriceBreakup.styles";

type PricingAmount = {
  text: {
    value: string;
    styles?: {
      color?: string;
      fontWeight?: string;
    };
  };
};

type PricingDetail = {
  label: string;
  amount: PricingAmount;
  description?: string;
};

type PriceBreakupData = {
  title: string;
  pricingDetails: PricingDetail[];
  netPricingDetails?: PricingDetail[];
};

const PriceBreakup = (data: PriceBreakupData) => {
  const { title, pricingDetails, netPricingDetails } = data;
  const { showNetPrice } = useNetPriceContext();
  const activePricingDetails = resolveNetPriceField(
    pricingDetails,
    netPricingDetails,
    showNetPrice
  );

  return (
    <PriceBreakupContainer>
      <PriceBreakupTitle>
        <FormattedText
          value={title}
          baseStyle={{
            fontWeight: 900,
            fontSize: "18px",
            color: theme.blackText,
          }}
        />
      </PriceBreakupTitle>

      {activePricingDetails.map((detail, index) => (
        <div key={`price-breakup-${index}`}>
          <>
            <FlexComp justifyContent="space-between" alignItems="center">
              <FormattedText
                value={detail.label}
                baseStyle={{
                  fontWeight: 700,
                  fontSize: "14px",
                  color: theme.greyText,
                }}
              />
              <FormattedText
                value={detail.amount}
                baseStyle={{
                  fontWeight: 700,
                  fontSize: "14px",
                  color: theme.greyText,
                }}
              />
            </FlexComp>

            {detail.description && (
              <FormattedText
                value={detail.description}
                baseStyle={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: theme.greyText,
                  marginTop: "4px",
                }}
              />
            )}
          </>

          {index < activePricingDetails.length - 1 && <PriceItemSeparator />}
        </div>
      ))}
    </PriceBreakupContainer>
  );
};

export default PriceBreakup;
